import {
  Card,
  DialogActions,
  FormControl,
  Grid,
  TextField,
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import CardContent from "@material-ui/core/CardContent";
import CircularProgress from "@material-ui/core/CircularProgress";
import Fab from "@material-ui/core/Fab";
import MenuItem from "@material-ui/core/MenuItem";
import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import Add from "@material-ui/icons/Add";
import Search from "@material-ui/icons/Search";
import AutocompleteExtension from "components/autocomplete/AutocompleteExtension";
import AutocompleteUser from "components/autocomplete/AutocompleteUser";
import Select from "components/select/Select";
import _, { cloneDeep, debounce } from "lodash";
import { PureComponent } from "react";
import {
  SelectValidator,
  TextValidator,
  ValidatorForm,
} from "react-material-ui-form-validator";
import { connect } from "react-redux";

import Dialog from "../../components/Dialog";
import SelectAutoComplete from "../../components/SelectAutoComplete";
import TableData from "../../components/TableData";
import datetimeHelper from "../../helper/datetime-helper";
import { globalHistory } from "../../history";
import { mapActionsToProps } from "../../redux/agent";
import { mapActionsToProps as extensionAction } from "./../../redux/cloudPBX/extension";
import { mapActionsToProps as TicketAction } from "./../../redux/miniCrm/ticket";
import { mapActionsToProps as userAction } from "./../../redux/user";

const styles = (theme) => ({
  model: {
    width: "100%",
  },
  card: {
    maxWidth: "100%",
    overflow: "unset",
  },
  form: {
    width: "100%",
  },
  input: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
  chip: {
    margin: theme.spacing.unit,
  },
  fab: {
    margin: theme.spacing.unit * 3,
  },
});

function filterCustomers(array, search) {
  if (search) {
    return search
      ? array.filter(
          (item) =>
            (item &&
              item.username &&
              item.username.toLowerCase().includes(search.toLowerCase())) ||
            (item &&
              item.name &&
              item.name.toLowerCase().includes(search.toLowerCase())) ||
            (item &&
              item.fullname &&
              item.fullname.toLowerCase().includes(search.toLowerCase())) ||
            (item &&
              item.extensionText &&
              item.extensionText.toLowerCase().includes(search.toLowerCase()))
        )
      : array;
  }
  return array;
}

class Agent extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      length: 0,
      data: [],
      modalSend: false,
      filters: {
        order: "createdAt DESC",
        where: {
          gte: null,
          lte: null,
        },
        page: 0,
        pageSize: 20,
      },
      // query: 'all',
      item: null,
      modalAction: false,
      modalDelete: false,
      fullname: "",
      extensionId: "",
      groupId: "",
      userId: "",
      attributes: {},
      name: "",
      listAgentGroups: null,
      listUser: null,
      listExtension: null,
      subOrgs: [],
      selectedSubOrg: "",
    };
  }
  componentDidMount() {
    this.itemInit();
    this.history = globalHistory();
    this.props.getSubOrg();
  }

  static getDerivedStateFromProps(props, state) {
    if (
      JSON.parse(JSON.stringify(state.subOrgs)) !==
        JSON.parse(JSON.stringify(_.values(props.subOrgs))) &&
      !state.subOrgs.length
    ) {
      return {
        subOrgs: _.values(props.subOrgs),
      };
    }
    return null;
  }

  listCollumns = [
    {
      id: "code",
      numeric: true,
      disablePadding: false,
      label: "Mã điện thoại viên",
    },
    { id: "user", numeric: true, disablePadding: false, label: "Tài khoản" },
    {
      id: "attributes",
      _attributes: "Employee",
      numeric: true,
      disablePadding: false,
      label: "Employee",
    },
    { id: "extension", numeric: true, disablePadding: false, label: "Máy lẻ" },
    { id: "status", numeric: true, disablePadding: false, label: "Trạng thái" },
    {
      id: "group",
      numeric: true,
      disablePadding: false,
      label: "Nhóm nhân viên",
    },
    { id: "action", numeric: true, disablePadding: false, label: "Hành động" },
  ];

  itemInit() {
    const where = {};
    const and = [];
    const { filters } = this.state;
    for (const key in filters.where) {
      if (filters.where.hasOwnProperty(key)) {
        const element = filters.where[key];
        if (element) {
          switch (key) {
            case "extensionId":
            case "name":
            case "userId":
            case "group.name":
            default: {
              if (key.startsWith("from") || key.startsWith("to")) {
                if (key == "from") {
                  and.push({ time: { gte: this.state.filters.where.from } });
                  where.and = and;
                } else {
                  and.push({ time: { lte: this.state.filters.where.to } });
                  where.and = and;
                }
              } else {
                where[key] = element;
              }
              break;
            }
          }
        }
      }
    }
    this.props.countListAgent({ where: where });
    this.props.getListAgent(
      filters.order,
      filters.pageSize,
      filters.page,
      {
        where,
      },
      {
        include: [
          { relation: "group", scope: { fields: { id: true, name: true } } },
        ],
      }
    );
    this.props.getListGroupAgent(filters.order, 999, null, null);
    this.props.getListExtension(filters.order, 999, null, null, {
      include: ["pbx"],
    });
    this.props.getAllUser(filters.order, 999, null, null);
  }

  openDialogCreate = () => {
    this.setState({ modalSend: !this.state.modalSend });
  };

  handleClose = () => {
    this.setState({ modalSend: false, modalAction: false, modalDelete: false });
  };

  openModalEdit = (item) => {
    this.setState({ selectedSubOrg: "" });
    this.props.getEmployeeSF(
      item.attributes.Employee.name
        ? item.attributes.Employee.name.split(" - ")[0]
        : "",
      10
    );
    setTimeout(() => {
      this.setState({
        modalAction: true,
        attributes: { ...item.attributes.Employee },
        item,
      });
    }, 500);
    if (item.subOrg) {
      this.setState({ selectedSubOrg: item.subOrg });
    }
  };

  openModalDelete = (item) => {
    this.setState({ modalDelete: true, attributes: {}, item });
  };

  handleChangePage = (e, page) => {
    const { filters } = this.state;
    this.setState({ page });
    filters.page = page * filters.pageSize;
    this.itemInit();
  };

  handleChangeRowsPerPage = (e) => {
    const { filters } = this.state;
    filters.pageSize = e.target.value;
    this.setState(
      {
        filters,
      },
      () => {
        this.itemInit();
      }
    );
  };

  handleSearchCode = (e) => {
    e.preventDefault();
    const value = e.target.value;
    this.setState({
      filters: {
        ...this.state.filters,
        where: {
          ...this.state.filters.where,
          code: value,
        },
      },
    });
  };
  handleSubmit = (e) => {
    const { filters } = this.state;
    filters.skip = 0;
    this.setState(
      {
        disable: false,
        filters: {
          ...filters,
          page: 0,
        },
      },
      () => {
        setTimeout(() => {
          this.itemInit();
        }, 1000);
      }
    );
  };

  handleDateChangeStart = (from) => {
    const { filters } = this.state;
    filters.where.from = datetimeHelper.toFormat(from, "YYYY-MM-DD");
    this.setState({ from });
  };

  handleDateChangeEnd = (to) => {
    const { filters } = this.state;
    filters.where.to = datetimeHelper.toFormat(to, "YYYY-MM-DD");
    this.setState({ to });
  };

  handleChangeText = (name) => {
    return (e) => {
      this.setState({
        itemCreate: {
          ...this.state.itemCreate,
          [name]: e.target.value,
        },
      });
    };
  };

  handleChangeTextEdit = (name) => {
    return (e) => {
      this.setState({
        item: {
          ...this.state.item,
          [name]: e.target.value,
        },
      });
    };
  };
  handleCreateModel = () => {
    this.setState({
      modalAction: true,
      item: null,
      attributes: null,
      itemCreate: {},
      selectedSubOrg: "",
    });
  };

  handleAction = (e) => {
    e.preventDefault();
    if (this.state.item) {
      const { id, code, userId, extensionId, groupId } = this.state.item;
      let _attributes = [];
      _attributes.push({
        attributes: {
          Employee: {
            id: this.state.attributes.id,
            name: this.state.attributes.name,
          },
        },
      });
      return (
        this.props.editAgent(
          id,
          extensionId,
          code,
          userId,
          groupId,
          _attributes[0],
          this.state.selectedSubOrg
        ),
        this.setState({ modalAction: false }),
        setTimeout(
          function () {
            this.itemInit();
          }.bind(this),
          1500
        )
      );
    } else {
      const { code, userId, extensionId, groupId } = this.state.itemCreate;
      const { attributes, selectedSubOrg } = this.state;

      let _attributes = [];

      _attributes.push({
        attributes: {
          Employee: {
            id: attributes ? attributes.id : null,
            name: attributes ? attributes.name : null,
          },
        },
      });
      return (
        this.props.addNewAgent(
          extensionId,
          code,
          userId,
          groupId,
          _attributes[0],
          selectedSubOrg
        ),
        this.setState({ modalAction: false }),
        setTimeout(
          function () {
            this.itemInit();
          }.bind(this),
          1500
        )
      );
    }
  };

  handleDelete = () => {
    this.props.deleteAgent(this.state.item.id);
    setTimeout(
      function () {
        this.setState({ modalDelete: false });
        this.itemInit();
      }.bind(this),
      1000
    );
  };

  handleSearchEmployee = (text) => {
    this.props.getEmployeeSF(text, 10);
  };

  handleToggle = (item) => {
    this.setState({
      attributes: item,
    });
  };

  onHandleKeyPress = (e) => {
    if (e.key === "Enter") {
      this.handleSubmit();
    }
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      prevProps.listAgentGroups !== this.props.listAgentGroups ||
      prevProps.listUser !== this.props.listUser ||
      prevProps.listExtension !== this.props.listExtension
    ) {
      const { listAgentGroups, listUser, listExtension } = this.props;

      const listAgentGroupsResult =
        typeof listAgentGroups === "object"
          ? Object.keys(listAgentGroups).map((key) => listAgentGroups[key])
          : listAgentGroups;
      const listUserResult =
        typeof listUser === "object"
          ? Object.keys(listUser).map((key) => listUser[key])
          : listUser;
      const listExtensionResult =
        typeof listExtension === "object"
          ? Object.keys(listExtension).map((key) => listExtension[key])
          : listExtension;

      this.setState({
        listAgentGroups: listAgentGroupsResult,
        listUser: listUserResult,
        listExtension: listExtensionResult.map((val) => {
          return {
            ...val,
            extensionText: `${val.name} - ${val.username}`,
          };
        }),
      });
    }
  }

  onFilterLocal = (search, type) => {
    const { listAgentGroups, listUser, listExtension } = this.state;

    if (type === "userId") {
      this.setState({
        listUser: filterCustomers(listUser, search),
      });
    }

    if (type === "groupId") {
      this.setState({
        listAgentGroups: filterCustomers(listAgentGroups, search),
      });
    }
  };

  handleSearchSubOrg = (text) => {
    const { subOrgs } = this.props;
    this.setState({
      subOrgs: this.filterSubOrgs(_.values(subOrgs), text),
    });
  };

  filterSubOrgs = (array, search) => {
    if (search) {
      return search
        ? array.filter(
            (item) =>
              item &&
              item.name &&
              item.name.toLowerCase().includes(search.toLowerCase())
          )
        : array;
    }
    return array;
  };

  render() {
    const {
      classes,
      listAgents,
      coutAgent,
      listAgentGroups,
      listExtension,
      listUser,
      employee,
      subOrgs,
    } = this.props;
    const {
      id,
      code,
      userId,
      extensionId,
      groupId,
      filters,
      item,
      modalDelete,
      modalAction,
      subOrg,
      itemCreate,
    } = this.state;
    const listAgentGroupsResult =
      typeof listAgentGroups === "object"
        ? Object.keys(listAgentGroups).map((key) => listAgentGroups[key])
        : listAgentGroups;
    const listAgentsResult =
      typeof listAgents === "object"
        ? Object.keys(listAgents).map((key) => listAgents[key])
        : listAgents;
    const listUserResult =
      typeof listUser === "object"
        ? Object.keys(listUser).map((key) => listUser[key])
        : listUser;
    const listExtensionResult =
      typeof listExtension === "object"
        ? Object.keys(listExtension).map((key) => listExtension[key])
        : listExtension;
    const listSubOrg =
      typeof subOrgs === "object"
        ? Object.keys(subOrgs).map((key) => subOrgs[key])
        : subOrgs;
    return (
      <div>
        <ValidatorForm
          ref="form"
          onSubmit={this.handleSubmit}
          onError={(errors) => console.log(errors)}
          className={classes.form}>
          <Card className={classes.card}>
            <CardContent>
              <Grid container spacing={24}>
                <Grid item xs={12} sm={12} md={2} xl={2} lg={2}>
                  <TextField
                    id="outlined-full-width"
                    margin="normal"
                    label="Mã điện thoại viên"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleSearchCode}
                    value={filters.where.code}
                    name="code"
                    onKeyPress={(e) => this.onHandleKeyPress(e)}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={2}
                  xl={3}
                  lg={3}
                  style={{ paddingTop: "24px" }}>
                  <AutocompleteUser
                    value={this.state.filters?.where?.userId?.like ?? ""}
                    onChange={(userId) => {
                      const newFilters = cloneDeep(this.state.filters);

                      newFilters.where.userId = {
                        like: userId ?? "",
                      };

                      this.setState(
                        {
                          filters: newFilters,
                        },
                        () => {
                          this.handleSubmit();
                        }
                      );
                    }}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={2}
                  xl={2}
                  lg={2}
                  style={{ paddingTop: "24px" }}>
                  <AutocompleteExtension
                    value={this.state.filters?.where?.extensionId?.like ?? ""}
                    onChange={(extensionId) => {
                      const newFilters = cloneDeep(this.state.filters);

                      newFilters.where.extensionId = {
                        like: extensionId ?? "",
                      };

                      this.setState(
                        {
                          filters: newFilters,
                        },
                        () => {
                          this.handleSubmit();
                        }
                      );
                    }}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={2}
                  xl={2}
                  lg={2}
                  style={{ paddingTop: "24px" }}>
                  <SelectAutoComplete
                    label={"Nhóm"}
                    data={
                      this.state.listAgentGroups &&
                      this.state.listAgentGroups.length > 0 &&
                      this.state.listAgentGroups.map((val) => {
                        return {
                          id: val.id,
                          label: val.name,
                        };
                      })
                    }
                    onSearch={debounce(
                      (text) => this.onFilterLocal(text, "groupId"),
                      300
                    )}
                    onChange={(item) => {
                      const value = item ? item.id : "";
                      const name = "groupId";
                      const { filters } = this.state;
                      filters.where[name] = value;
                      this.setState(
                        {
                          filters,
                        },
                        () => {
                          this.handleSubmit();
                        }
                      );
                    }}
                    onClear={true}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={2} xl={2} lg={2}>
                  <Tooltip title="Tìm kiếm" disableFocusListener>
                    <Fab
                      color="primary"
                      aria-label="Search"
                      className={classes.fab}
                      onClick={this.handleSubmit}>
                      <Search />
                    </Fab>
                  </Tooltip>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </ValidatorForm>
        <TableData
          {...this.props}
          nameTable="Danh sách điện thoại viên"
          items={listAgentsResult}
          rowsPerPage={filters.pageSize}
          count={coutAgent}
          page={
            filters.pageSize === 20
              ? filters.page / 20
              : filters.pageSize === 40
              ? filters.page / 40
              : filters.pageSize === 60
              ? filters.page / 60
              : filters.pageSize === 80
              ? filters.page / 80
              : filters.page / 100
          }
          rowItems={this.listCollumns}
          allowCreate={true}
          handleEdit={this.openModalEdit}
          handleDelete={this.openModalDelete}
          handleChangePage={this.handleChangePage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          createAction={
            <Tooltip title="Thêm mới" disableFocusListener>
              <Fab
                color="primary"
                aria-label="add"
                className={classes.fab}
                onClick={this.handleCreateModel}
                size="small">
                <Add className={classes.add} />
              </Fab>
            </Tooltip>
          }
        />
        <Dialog
          open={modalAction}
          title={
            item
              ? "Chỉnh sửa thông tin điện thoại viên"
              : "Thêm điện thoại viên"
          }
          input={
            <ValidatorForm
              ref="form"
              onSubmit={this.handleAction}
              onError={(errors) => console.log(errors)}
              className={classes.form}>
              <FormControl className={classes.form}>
                <Grid container className={classes.grid}>
                  <TextValidator
                    margin="normal"
                    label="Mã điện thoại viên"
                    variant="outlined"
                    className={classes.input}
                    autoFocus={true}
                    onChange={
                      item && item.id
                        ? this.handleChangeTextEdit("code")
                        : this.handleChangeText("code")
                    }
                    value={item && item.id ? item.code : itemCreate?.code}
                    name="code"
                    validators={["required"]}
                    errorMessages={[`Không được để trống`]}
                  />

                  <SelectValidator
                    margin="normal"
                    label="Tài khoản"
                    variant="outlined"
                    className={classes.input}
                    onChange={
                      item && item.id
                        ? this.handleChangeTextEdit("userId")
                        : this.handleChangeText("userId")
                    }
                    value={
                      item && item.id
                        ? item.userId || ""
                        : itemCreate?.userId || ""
                    }
                    select
                    name="userId"
                    validators={["required"]}
                    errorMessages={[`Không được để trống`]}>
                    {listUserResult
                      ? listUserResult.map((val) => {
                          return (
                            <MenuItem key={val.id} value={val.id}>
                              {val.username}
                            </MenuItem>
                          );
                        })
                      : null}
                  </SelectValidator>

                  <div
                    style={{ marginTop: 12, marginBottom: 8, width: "100%" }}>
                    <AutocompleteExtension
                      value={item?.id ? item.extension : itemCreate?.extension}
                      onChange={(newValue) => {
                        const extensionId = newValue?.id || "";
                        if (item?.id) {
                          this.setState((prev) => ({
                            item: {
                              ...prev.item,
                              extensionId,
                              extension: newValue || null,
                            },
                          }));
                        } else {
                          this.setState((prev) => ({
                            itemCreate: {
                              ...prev.itemCreate,
                              extensionId,
                              extension: newValue,
                            },
                          }));
                        }
                      }}
                      labelInValue
                    />
                  </div>

                  <SelectValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Nhóm"
                    variant="outlined"
                    className={classes.input}
                    onChange={
                      item && item.id
                        ? this.handleChangeTextEdit("groupId")
                        : this.handleChangeText("groupId")
                    }
                    value={
                      item && item.id
                        ? item.groupId || ""
                        : itemCreate?.groupId || ""
                    }
                    select
                    name="groupId"
                    validators={["required"]}
                    errorMessages={[`Không được để trống`]}>
                    {listAgentGroupsResult
                      ? listAgentGroupsResult.map((it) => {
                          return (
                            <MenuItem key={it.id} value={it.id}>
                              {it.name}
                            </MenuItem>
                          );
                        })
                      : null}
                  </SelectValidator>
                  {item ? (
                    <TextField
                      id="outlined-full-width"
                      margin="normal"
                      label="Nhân viên hiện tại"
                      variant="outlined"
                      className={classes.input}
                      value={item ? item.attributes.Employee.name : ""}
                      disabled
                      // InputLabelProps={{
                      //     shrink: true,
                      // }}
                    />
                  ) : null}
                  <SelectAutoComplete
                    label={item ? "Thay đổi nhân viên" : "Chọn nhân viên"}
                    data={
                      employee && employee.length > 0
                        ? employee.map((val) => {
                            return {
                              id: val.Id,
                              label: val.Name + " - " + val.Employee_Code__c,
                              name: val.Name + " - " + val.Employee_Code__c,
                            };
                          })
                        : []
                    }
                    className={classes.input}
                    // required={!item}
                    onSearch={debounce(this.handleSearchEmployee, 300)}
                    onChange={(data) =>
                      this.setState({
                        attributes: data ? { ...data } : null,
                      })
                    }
                    onClear={true}
                    loading={this.props.loadingEp}
                  />
                  <div
                    style={{
                      marginTop: "20px",
                      marginBottom: "8px",
                      width: "100%",
                    }}>
                    <Select
                      label="Bộ phận"
                      options={
                        this.state.subOrgs?.map((val) => {
                          return {
                            value: val.code,
                            label: val.name,
                          };
                        }) || []
                      }
                      value={this.state.selectedSubOrg || ""}
                      onChange={(code) => {
                        this.setState({
                          selectedSubOrg: code || "",
                        });
                      }}
                      allowClear
                    />
                  </div>
                </Grid>
              </FormControl>
              <DialogActions>
                <Button
                  onClick={this.handleClose}
                  color="secondary"
                  className={classes.button}>
                  Hủy
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  className={classes.button}>
                  Lưu
                </Button>
              </DialogActions>
            </ValidatorForm>
          }
          onClose={this.handleClose}
        />
        <Dialog
          open={modalDelete}
          title={`Bạn có muốn xóa điện thoại viên?`}
          button={true}
          onSubmit={this.handleDelete}
          onClose={this.handleClose}
        />
        <Dialog open={this.props.loading} title={<CircularProgress />} />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  listAgents: state.agent.agents,
  loading: state.agent.loading,
  coutAgent: state.agent.countAgent,
  listAgentGroups: state.agent.groupAgent,
  listExtension: state.extension.extensions,
  listUser: state.user.users,
  employee: state.ticket.employee,
  loadingEp: state.ticket.loadingEp,
  subOrgs: state.user.subOrgs,
});

const Extension = connect(null, extensionAction)(Agent);
const User = connect(null, userAction)(Extension);
const Ticket = connect(null, TicketAction)(User);
Agent = connect(mapStateToProps, mapActionsToProps)(Ticket);

export default withStyles(styles)(Agent);
